import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20reading%20nook%20with%20an%20elegant%20open%20graphic%20novel%20on%20a%20rich%20wooden%20table%2C%20soft%20golden%20evening%20light%20streaming%20through%20sheer%20curtains%2C%20cozy%20interior%20with%20bookshelves%20in%20background%2C%20storytelling%20and%20literary%20ambiance%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=1600&height=900&seq=hero-manga-01&orientation=landscape"
          alt="继母的朋友们漫画 - 完整剧情介绍与角色解析"
          title="继母的朋友们漫画 - 完整剧情介绍与角色解析"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      <div className="absolute inset-0 flex items-center justify-center px-4 md:px-6">
        <div className="text-center w-full max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
            继母的朋友们漫画
          </h1>
          <p className="text-base md:text-lg text-background-100/90 mb-6 leading-relaxed max-w-2xl mx-auto">
            深度解析继母的朋友们漫画的完整剧情、角色关系与最新更新资讯，帮助漫画爱好者快速掌握全貌，找到最佳阅读入口
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/plot"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览剧情介绍
            </Link>
            <Link
              to="/category/reading"
              className="px-6 py-3 bg-background-50/20 text-background-50 border border-background-50/30 rounded-md font-medium text-sm hover:bg-background-50/30 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              在线阅读指南
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}